import { Component, Input, OnInit, Output, EventEmitter, Injector } from '@angular/core';
import { profileQualificationI } from 'app/core/interfaces/layout';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { Qualification } from 'app/core/interfaces/qualification';
import { Communication } from 'app/core/interfaces/communication';
import { Accessibility } from 'app/core/interfaces/accessibility';

@Component({
  selector: 'page-practitioner-qualification-form',
  templateUrl: './qualification-form.component.html',
  styleUrls: ['./qualification-form.component.scss'],
})
export class PractitionerQualificationFormComponent extends BaseComponent implements OnInit {
  @Input() public qualifications: Qualification[] = [];
  @Input() public courses: Qualification[] = [];
  @Input() public languages: Communication[] = [];
  @Input() public accessibilities: Accessibility[] = [];
  @Output() onUpdatePractitioner = new EventEmitter<Practitioner>();

  @Input() practitioner: Practitioner = <Practitioner>{};
  @Input() mode = 'CREATE';

  public titleLanguages = 'Idiomas';
  public titleQualifications = 'Qualificações';
  public titleCourses = 'Cursos/Certificados';
  public titleAccessibilities = 'Acessibilidades';
  public countAccessibility = 0;
  public proficiencyLevels = [
    { value: 'A1', label: 'A1 - Iniciante' },
    { value: 'A2', label: 'A2 - Básico' },
    { value: 'B1', label: 'B1 - Intermediário' },
    { value: 'B2', label: 'B2 - Intermediário Avançado' },
    { value: 'C1', label: 'C1 - Avançado' },
    { value: 'C2', label: 'C2 - Proficiência' },
  ];
  public accessibilitiesValues = [
    { value: 'libras', label: 'Libras - Língua Brasileira de Sinais' },
    { value: 'braille', label: 'Braille' },
    { value: 'audio-description', label: 'Áudio-Descrição' },
  ];
  public isSaving = false;
  private practitionerId = '';

  @Input() actor: string = '';

  constructor(private practitionerService: PractitionerService, private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    const userLogged = this.getUserLogged();

    if (this.mode == 'CREATE') {
      this.practitionerId = this.practitioner?.practitioner_id;
    }

    if (this.mode == 'UPDATE') {
      this.practitionerId = userLogged.id;
    }

    if (localStorage.getItem('isFirstAccess') == 'false') {
      this.getPractitioner();
    }

    this.formatValues();
  }

  private getPractitioner() {
    const practitionerId = this.getUserLogged().id;

    this.practitionerService.showNew(practitionerId).subscribe({
      next: (practitioner: Practitioner) => {
        this.practitioner = practitioner;
        this.qualifications = practitioner.qualifications || [];
        this.courses = practitioner.certificates || [];
        this.languages = practitioner.communication || [];
        this.accessibilities = practitioner.accessibilities || [];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onChangeForm() {
    const retorno: any = {
      qualifications: this.qualifications,
      courses: this.courses,
      communication: this.languages,
      accessibilities: this.accessibilities,
    };
    //this.onUpdate.emit(retorno);
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;

    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  addQualification() {
    if (!this.qualifications) {
      this.qualifications = [];
    }

    this.qualifications.unshift({
      name: '',
      instituition: '',
      dateConclusion: '',
      level: '',
      type: 'QUALIFICATION',
    });
  }

  addCourse() {
    if (!this.courses) {
      this.courses = [];
    }
    this.courses.unshift({
      name: '',
      instituition: '',
      dateConclusion: '',
      level: 'CURSO',
      type: 'COURSE',
    });
  }

  addLanguage() {
    if (!this.languages) {
      this.languages = [];
    }

    this.languages.unshift({
      language: '',
      preferred: false,
      proficiency: ''
    });
  }

  addAccessibility(): void {

    if (this.accessibilitiesValues.length >= this.countAccessibility) {
      this.countAccessibility++;
      this.accessibilities.unshift({ name: '' });
    }
  }

  formatValues() {
    if (this.qualifications && this.qualifications.length > 0) {
      this.qualifications.forEach(
        (item: Qualification) => (item.dateConclusion = item.dateConclusion ? this.layout.getDatePtFormat(item.dateConclusion) : '')
      );
    }
    if (this.courses && this.courses.length > 0) {
      this.courses.forEach(
        (item: Qualification) => (item.dateConclusion = item.dateConclusion ? this.layout.getDatePtFormat(item.dateConclusion) : '')
      );
    }
  }

  objectIsEmpty(obj?: any): boolean {

    if (obj == null) return true;

    if (Array.isArray(obj)) {
      return obj.length === 0;
    }

    if (typeof obj === 'object') {
      const values = Object.values(obj);
      return values.every(
        v =>
          v === null ||
          v === undefined ||
          (typeof v === 'string' && v.trim() === '')
      );
    }

    return false;
  }

  save() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.isSaving = true;

    const practitioner_id = this.getUserLogged().id;

    const practitionerFormValues = {
      ...this.practitioner,
      ...this.qualifications,
      ...this.courses,
      ...this.languages,
      ...this.accessibilities,
    };

    this.practitionerService.updateNew(practitioner_id, practitionerFormValues).subscribe({
      next: (practioner: Practitioner) => {
        this.showSuccessMessage = true;
        this.isSaving = false;
        this.practitioner = practioner;

        this.onUpdatePractitioner.emit(practioner)

        if (this.objectIsEmpty(this.practitioner?.address)){
            setTimeout(() => {
              this.router.navigate(
                ['medico/meus-dados'],
                { queryParams: { tab: 'localizacao' } }
              );
              this.loading = false;
          }, 500);
        }

         
      },
      error: (err) => {
        this.showErrorMessage = true;
        this.isSaving = false;
        console.log(err);
      },
    });
  }
}
